module.exports = __webpack_public_path__ + "static/media/justify-lg-4.296d0ece.jpg";